import { createContext } from 'react';
export const defaultValue = {
    addToast: () => undefined,
    cancelToast: () => undefined,
};
export const CFToastProviderContext = createContext(defaultValue);
